import { safeNumericString } from 'app/infrastructure/data/sanitize';

const breadcrumbsKeys = ['codetableId0', 'codetableId1', 'codetableId2', 'codetableId3', 'codetableId4', 'codetableId5', 'codetableId6', 'codetableId7'] as const;

export type breadcrumbsParams = { [key in typeof breadcrumbsKeys[number]]: string };

export const getBreadcrumbs = (params: breadcrumbsParams) => breadcrumbsKeys
  .map(key => safeNumericString(params[key]))
  .filter(item => item !== '') as number[];

export const getCodetableId = (breadcrumbs: number[]) => {
  return (breadcrumbs?.length ?? 0) > 0 ? breadcrumbs[breadcrumbs.length - 1] : undefined;
};
